// redux/actions/oliCategoryAction.js
import { ActionTypes } from "../constants/action-types";

export const setOliCategory = (category) => {
  return {
    type: ActionTypes.SET_OLI_CATEGORY,
    payload: category,
  };
};

export const openOliPopup = () => {
  return {
    type: ActionTypes.OPEN_OLI_POPUP,
  };
};

export const closeOliPopup = () => {
  return {
    type: ActionTypes.CLOSE_OLI_POPUP,
  };
};

export const displayFeedbackPopup = (displayFeedbackPopup) => {
  return {
    type: ActionTypes.DISPLAY_FEEDBACK_POPUP,
    payload: displayFeedbackPopup,
  };
};